<template>
  <CTabs variant="tabs" class="nav-tabs-boxed">
    <CTab title="Tags">
      <crud-base
        :url="url"
        :columns="columns"
        :onDelete="() => {}"
        :onUpdate="() => {}"
        :canDelete="(row) => row.chave === null"
        :canUpdate="(row) => row.chave === null"
        :onStore="() => {}"
        :onShow="() => {}"
        :onClone="onClone"
        :enableSearch="true"
        :formInputs="formInputs"
        :transformStore="transformData"
        :transformUpdate="transformData"
        :filters="filters"
        primaryKey="id"
      >
        <template v-slot:filter-search>
          <select class="form-control form-control-sm" v-model="filters.entidade" style="width: 180px; display: inline-block; margin-left: 10px; vertical-align: middle;">
            <option value="">Todos os tipos</option>
            <option value="cliente">Cliente</option>
            <option value="orcamento">Orçamento</option>
            <option value="pedido">Pedido</option>
            <option value="produto">Produto</option>
          </select>
        </template>
      </crud-base>
    </CTab>
  </CTabs>
</template>

<script>
import CrudBase from "../../components/crud/CrudBase";
import {yesNoRepresentation} from "@/helpers/transformers";
import {
  schemaBoolean,
  schemaSelect,
  schemaTextArea,
  schemaTextField
} from "@/helpers/form";
export default {
  name: "tag-filtro",
  components: {
    CrudBase,
  },
  data() {
    return {
      url: "/admin/tag-filtro",
      filters: {
        entidade: "",
      },
      columns: [
        { label: "ID", field: "id", sortable: false },
        { label: "TITULO", field: "titulo", sortable: false },
        { label: "DESCRICAO", field: "descricao", sortable: false },
        { label: "TIPO", field: "entidade", sortable: false },
        { label: "ATIVO", field: "ativo", sortable: false, representedAs: (row) => yesNoRepresentation(row.ativo)},
        { label: "PERSONALIZADA", field: "chave", sortable: false, representedAs: (row) => row.chave !== null ? 'Não' : 'Sim'},
        { label: "MODO", field: "condicoes", sortable: false, representedAs: (row) => row.condicoes ? 'Visual' : 'SQL'},
      ],
      formInputs: {
        titulo: schemaTextField('Título', true, 6),
        entidade: schemaSelect('Tipo de tag', true, 3, {
          "cliente" : "Cliente",
          "orcamento" : "Orçamento",
          "pedido" : "Pedido",
          "produto" : "Produto",
        }),
        ativo: schemaBoolean('Ativo', 1, 3, true),
        descricao: schemaTextArea('Descrição', true, 12),
        condicoes: {
          type: 'string',
          ui: {
            widget: 'ConditionBuilder',
            label: 'Condições',
            columns: 12,
          },
        },
      },
    };
  },
  methods: {
    onClone(row) {
      delete row['chave'];
      // Ao clonar, manter condicoes se existir
      if (row.condicoes) {
        row.clausula = null;
      }
    },
    transformData(data) {
      // Tentar parsear condicoes se for string JSON válida com grupos
      if (data.condicoes && typeof data.condicoes === 'string') {
        try {
          const parsed = JSON.parse(data.condicoes);
          if (parsed && parsed.grupos) {
            data.condicoes = parsed;
            data.clausula = null;
            return data;
          }
        } catch {
          // Se não é JSON válido com grupos, é SQL bruto
        }
        // É SQL bruto (modo SQL)
        data.clausula = data.condicoes;
        data.condicoes = null;
      }
      return data;
    },
  },
};
</script>
